/**
 * Do not edit directly, this file was auto-generated.
 */

export const charcoal = "rgb(35, 33, 33)";
export const charcoalTint = "rgb(154, 153, 153)";
export const charcoalMid = "rgb(108, 106, 106)";
export const charcoalShade = "rgb(25, 23, 23)";
export const charcoal50 = "rgb(233, 233, 233)";
export const charcoal100 = "rgb(187, 186, 186)";
export const charcoal200 = "rgb(154, 153, 153)";
export const charcoal300 = "rgb(108, 106, 106)";
export const charcoal400 = "rgb(79, 77, 77)";
export const charcoal500 = "rgb(35, 33, 33)";
export const charcoal600 = "rgb(32, 30, 30)";
export const charcoal700 = "rgb(25, 23, 23)";
export const charcoal800 = "rgb(19, 18, 18)";
export const charcoal900 = "rgb(15, 14, 14)";
export const coolGray = "rgb(249, 249, 250)";
export const coolGray50 = "rgb(249, 249, 250)";
export const coolGray100 = "rgb(235, 238, 240)";
export const coolGray200 = "rgb(226, 229, 232)";
export const coolGray300 = "rgb(213, 217, 222)";
export const coolGray400 = "rgb(205, 210, 216)";
export const coolGray500 = "rgb(192, 199, 206)";
export const coolGray600 = "rgb(175, 181, 187)";
export const coolGray700 = "rgb(136, 141, 146)";
export const coolGray800 = "rgb(106, 109, 113)";
export const coolGray900 = "rgb(81, 84, 87)";
export const cotton = "rgb(255, 252, 249)";
export const cottonTint = "rgb(249, 246, 240)";
export const cottonMid = "rgb(244, 237, 226)";
export const cottonShade = "rgb(233, 220, 198)";
export const cotton50 = "rgb(255, 255, 254)";
export const cotton100 = "rgb(255, 254, 253)";
export const cotton200 = "rgb(255, 254, 252)";
export const cotton300 = "rgb(255, 253, 251)";
export const cotton400 = "rgb(255, 252, 249)";
export const cotton500 = "rgb(252, 250, 247)";
export const cotton600 = "rgb(249, 246, 240)";
export const cotton700 = "rgb(244, 237, 226)";
export const cotton800 = "rgb(233, 220, 198)";
export const cotton900 = "rgb(174, 165, 148)";
export const eggplant = "rgb(116, 74, 110)";
export const eggplantTint = "rgb(191, 172, 188)";
export const eggplantMid = "rgb(162, 134, 158)";
export const eggplantShade = "rgb(64, 41, 61)";
export const eggplant50 = "rgb(241, 237, 241)";
export const eggplant100 = "rgb(212, 199, 210)";
export const eggplant200 = "rgb(191, 172, 188)";
export const eggplant300 = "rgb(162, 134, 158)";
export const eggplant400 = "rgb(144, 110, 139)";
export const eggplant500 = "rgb(116, 74, 110)";
export const eggplant600 = "rgb(106, 67, 100)";
export const eggplant700 = "rgb(82, 53, 78)";
export const eggplant800 = "rgb(64, 41, 61)";
export const eggplant900 = "rgb(49, 31, 46)";
export const orange = "rgb(255, 164, 62)";
export const orangeTint = "rgb(255, 213, 166)";
export const orangeMid = "rgb(255, 194, 126)";
export const orangeShade = "rgb(181, 116, 44)";
export const orange50 = "rgb(255, 246, 236)";
export const orange100 = "rgb(255, 227, 195)";
export const orange200 = "rgb(255, 164, 62)";
export const orange300 = "rgb(255, 194, 126)";
export const orange400 = "rgb(255, 182, 101)";
export const orange500 = "rgb(255, 164, 62)";
export const orange600 = "rgb(232, 149, 56)";
export const orange700 = "rgb(181, 116, 44)";
export const orange800 = "rgb(140, 90, 34)";
export const orange900 = "rgb(107, 69, 26)";
export const pink = "rgb(241, 192, 242)";
export const pinkTint = "rgb(249, 226, 249)";
export const pinkMid = "rgb(244, 205, 245)";
export const pinkShade = "rgb(171, 136, 172)";
export const pink50 = "rgb(254, 249, 254)";
export const pink100 = "rgb(251, 235, 251)";
export const pink200 = "rgb(249, 226, 249)";
export const pink300 = "rgb(246, 213, 246)";
export const pink400 = "rgb(244, 205, 245)";
export const pink500 = "rgb(241, 192, 242)";
export const pink600 = "rgb(219, 175, 220)";
export const pink700 = "rgb(171, 136, 172)";
export const pink800 = "rgb(133, 106, 133)";
export const pink900 = "rgb(101, 81, 102)";
export const poppy = "rgb(249, 99, 83)";
export const poppyTint = "rgb(252, 183, 176)";
export const poppyMid = "rgb(251, 150, 140)";
export const poppyShade = "rgb(177, 70, 59)";
export const poppy50 = "rgb(254, 239, 238)";
export const poppy100 = "rgb(253, 207, 202)";
export const poppy200 = "rgb(252, 183, 176)";
export const poppy300 = "rgb(251, 150, 140)";
export const poppy400 = "rgb(250, 130, 117)";
export const poppy500 = "rgb(249, 99, 83)";
export const poppy600 = "rgb(227, 90, 76)";
export const poppy700 = "rgb(177, 70, 59)";
export const poppy800 = "rgb(137, 54, 46)";
export const poppy900 = "rgb(105, 42, 35)";
export const sky = "rgb(156, 209, 239)";
export const skyTint = "rgb(209, 234, 248)";
export const skyMid = "rgb(189, 224, 244)";
export const skyShade = "rgb(111, 148, 170)";
export const sky50 = "rgb(245, 250, 253)";
export const sky100 = "rgb(224, 241, 250)";
export const sky200 = "rgb(209, 234, 248)";
export const sky300 = "rgb(189, 224, 244)";
export const sky400 = "rgb(176, 218, 242)";
export const sky500 = "rgb(156, 209, 239)";
export const sky600 = "rgb(142, 190, 217)";
export const sky700 = "rgb(111, 148, 170)";
export const sky800 = "rgb(86, 115, 131)";
export const sky900 = "rgb(66, 88, 100)";
export const stone = "rgb(219, 212, 204)";
export const stoneTint = "rgb(238, 235, 232)";
export const stoneMid = "rgb(231, 226, 221)";
export const stoneShade = "rgb(155, 151, 145)";
export const stone50 = "rgb(251, 251, 250)";
export const stone100 = "rgb(244, 242, 239)";
export const stone200 = "rgb(238, 235, 232)";
export const stone300 = "rgb(231, 226, 221)";
export const stone400 = "rgb(226, 221, 214)";
export const stone500 = "rgb(219, 212, 204)";
export const stone600 = "rgb(199, 193, 186)";
export const stone700 = "rgb(155, 151, 145)";
export const stone800 = "rgb(120, 117, 112)";
export const stone900 = "rgb(92, 89, 86)";
export const violet = "rgb(145, 118, 209)";
export const violetTint = "rgb(204, 192, 234)";
export const violetMid = "rgb(181, 163, 224)";
export const violetShade = "rgb(103, 84, 148)";
export const violet50 = "rgb(244, 241, 250)";
export const violet100 = "rgb(221, 213, 241)";
export const violet200 = "rgb(204, 192, 234)";
export const violet300 = "rgb(181, 163, 224)";
export const violet400 = "rgb(167, 145, 218)";
export const violet500 = "rgb(145, 118, 209)";
export const violet600 = "rgb(132, 107, 190)";
export const violet700 = "rgb(103, 84, 148)";
export const violet800 = "rgb(80, 65, 115)";
export const violet900 = "rgb(61, 50, 88)";
export const yellow = "rgb(252, 252, 126)";
export const yellowTint = "rgb(254, 254, 196)";
export const yellowMid = "rgb(253, 253, 169)";
export const yellowShade = "rgb(229, 229, 115)";
export const yellow50 = "rgb(255, 255, 242)";
export const yellow100 = "rgb(254, 254, 215)";
export const yellow200 = "rgb(254, 254, 196)";
export const yellow300 = "rgb(253, 253, 169)";
export const yellow400 = "rgb(253, 253, 152)";
export const yellow500 = "rgb(252, 252, 126)";
export const yellow600 = "rgb(229, 229, 115)";
export const yellow700 = "rgb(179, 179, 89)";
export const yellow800 = "rgb(139, 139, 69)";
export const yellow900 = "rgb(106, 106, 53)";
export const white = "rgb(255, 255, 255)";
export const lightSand = "rgb(255, 252, 249)";
export const lemon = "rgb(252, 252, 126)";
export const cedar = "rgb(116, 74, 110)";
export const cedarShade = "rgb(64, 41, 61)";
export const cedarTint = "rgb(191, 172, 188)";
export const charcoal85 = "rgb(81, 84, 87)";
export const charcoalMidTint = "rgb(108, 106, 106)";
export const lake = "rgb(156, 209, 239)";
export const lakePop = "rgb(252, 252, 126)";
export const lakeShade = "rgb(111, 148, 170)";
export const lakeTint = "rgb(209, 234, 248)";
export const lavender = "rgb(145, 118, 209)";
export const lavenderLight = "rgb(204, 192, 234)";
export const lavenderMidTint = "rgb(181, 163, 224)";
export const lavenderShade = "rgb(103, 84, 148)";
export const lavenderTint = "rgb(204, 192, 234)";
export const sandShade = "rgb(233, 220, 198)";
export const sandTint = "rgb(249, 246, 240)";
export const sand = "rgb(255, 252, 249)";
export const poppy06 = "rgb(177, 70, 59)";
